import { Navigate } from 'react-router-dom';

/** Alias route (stockerai-new: /sop-cycles → /planning-cycles). */
export function SopCyclesRedirect() {
  return <Navigate to="/demand-planning/sop/cycles" replace />;
}
